import React from 'react';

interface Section {
  id: number;
  title: string;
  icon: React.ComponentType<{ size?: number; className?: string }>;
  content: string;
  steps?: {
    number: number;
    title: string;
    description: string;
  }[];
}

interface CenterSectionProps {
  activeSection: number;
  sections: Section[];
}

const CenterSection: React.FC<CenterSectionProps> = ({ activeSection, sections }) => {
  return (
    <div className="w-full lg:w-[60%] z-20 flex-shrink-0 py-8">
      <div className="relative min-h-[350px] lg:h-[calc(100vh-8rem)]">
        {/* Background Giant C */}
        <div 
          className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-[30rem] opacity-25 pointer-events-none"
          style={{ 
            fontFamily: '"Anton", sans-serif',
            background: 'linear-gradient(135deg, #fbbf24 0%, #f97316 45%, #6366f1 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            filter: 'drop-shadow(0 20px 60px rgba(0,0,0,0.35))'
          }}
        >
          C
        </div>
        
        {/* Dynamic Content */}
        <div className="relative h-full flex items-center justify-center">
          <div className="bg-BLACK/90 backdrop-blur-xl rounded-3xl p-12 w-full h-full border border-WHITE/20 shadow-2xl flex flex-col">
            <div className="flex items-center gap-4 mb-8">
              {React.createElement(sections[activeSection].icon, { 
                size: 48, 
                className: 'text-ORANGE' 
              })}
              <h3 className="text-5xl font-bold text-WHITE">{sections[activeSection].title}</h3>
            </div>
            
            {/* Show steps if available (How It Works section) */}
            {sections[activeSection].steps ? (
              <div className="space-y-6">
                {sections[activeSection].steps.map((step) => (
                  <div key={step.number} className="flex gap-4 items-start">
                    <div className="flex-shrink-0 w-12 h-12 rounded-full bg-ORANGE flex items-center justify-center">
                      <span className="text-WHITE text-xl font-bold">{step.number}</span>
                    </div>
                    <div className="flex-1">
                      <h4 className="text-WHITE text-2xl font-bold mb-2">{step.title}</h4>
                      <p className="text-WHITE/80 text-lg leading-relaxed">{step.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-WHITE/80 text-xl leading-relaxed">
                {sections[activeSection].content}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CenterSection;
